import {
	FETCH_ALLOWANCES_SUCCESS,
	FETCH_ALLOWANCE_SUCCESS,
} from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
	switch (action.type) {
		case FETCH_ALLOWANCES_SUCCESS: {
			return { ...state, index: action.payload };
		}
		case FETCH_ALLOWANCE_SUCCESS: {
			return { ...state, show: action.payload };
		}
		default:
			return state;
	}
};
